import React from 'react';
import './SkeletonCard.css';

export function SkeletonCard() {
  return (
    <div className="skeleton-card">
      <div className="skeleton-line skeleton-title" />
      <div className="skeleton-line skeleton-tag" />
      <div className="skeleton-line skeleton-url" />
      <div className="skeleton-price-block">
        <div className="skeleton-line skeleton-price" />
        <div className="skeleton-line skeleton-subtext" />
      </div>
    </div>
  );
}

export function SkeletonQuoteRow() {
  return (
    <div className="skeleton-quote-row">
      <div className="skeleton-line skeleton-quote-title" />
      <div className="skeleton-line skeleton-quote-meta" />
    </div>
  );
}

export default SkeletonCard;
